<!-- nzValidateStatus="success" nzHasFeedback -->
<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
    <nz-date-picker nzMode="month" [id]="code" [(ngModel)]="value" (ngModelChange)="inputChanged()"
      [nzPlaceHolder]="title" [nzDisabled]="disabled" [nzAllowClear]="!required && !disabled" nzInputReadOnly
      [disabled]="disabled">
    </nz-date-picker>
  </nz-form-control>
</nz-form-item>